// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active {
  background-color: #00C1D4;
  color: #ffffff;
  font-weight: 500;
}

.subActive {
  background-color: #00C1D4 !important;
  font-weight: 500;
}

.sideBar {
  cursor: pointer;
}

.bold-item {
  font-weight: bold;
}

.mat-list-base {
  padding: 0;
}

.subMenu {
  padding-left: 1.5rem !important;
  color: #ffffff;
  background-color: rgba(127, 127, 127, 0.6784313725);
}

::ng-deep .sideBar .mat-list-item-content {
  justify-content: space-between;
  width: 100%;
}

*[ng-reflect-router-link]:focus {
  outline: none;
}

.dashboardDiv {
  display: flex;
  align-items: center;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/app/components/side-nav/side-nav.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,oCAAA;EACA,gBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAGA;EACI,UAAA;AAAJ;;AAGA;EACI,+BAAA;EACA,cAAA;EACA,mDAAA;AAAJ;;AAII;EACI,8BAAA;EACA,WAAA;AADR;;AAKA;EACI,aAAA;AAFJ;;AAKA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAFJ","sourcesContent":[".active {\n    background-color: #00C1D4;\n    color: #ffffff;\n    font-weight: 500;\n}\n\n.subActive {\n    background-color: #00C1D4!important;\n    font-weight: 500;\n}\n\n.sideBar {\n    cursor: pointer;\n}\n\n.bold-item {\n    font-weight: bold;\n  }\n\n\n.mat-list-base {\n    padding: 0;\n}\n\n.subMenu {\n    padding-left: 1.5rem!important;\n    color: #ffffff;\n    background-color: #7f7f7fad;\n}\n\n::ng-deep {\n    .sideBar .mat-list-item-content {\n        justify-content: space-between;\n        width: 100%;\n    }\n}\n\n*[ng-reflect-router-link]:focus {\n    outline: none;\n}\n\n.dashboardDiv{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
